import {
	type Product,
	type ProductImage,
	type ProductVariant,
} from "@prisma/client"
import { Link } from "react-router"
import { getProductImgSrc, price } from "#app/utils/misc"
import routes from "#routes"
import LoaderImage from "./loader-image"

type RelatedProduct = Pick<Product, "id" | "name" | "price" | "handle"> & {
	images: Pick<ProductImage, "id" | "altText">[]
	variants: Pick<ProductVariant, "id" | "price">[]
}

export default function RelatedProducts({
	products,
}: {
	products: RelatedProduct[]
}) {
	if (products.length === 0) return null

	return (
		<section className="mt-16 border-t border-border/40 pt-12">
			<h2 className="mb-8 text-2xl font-bold tracking-tight">
				Productos relacionados
			</h2>
			<div className="grid grid-cols-1 gap-x-6 gap-y-10 sm:grid-cols-2 lg:grid-cols-4 xl:gap-x-8">
				{products.map(product => (
					<Link
						className="group"
						to={routes.public.product.route(product.handle)}
						key={product.id}
						prefetch="intent"
					>
						<LoaderImage
							src={getProductImgSrc(product.images[0].id)}
							alt={product.images[0].altText || product.name}
							loading="lazy"
							decoding="async"
							fetchPriority="low"
						/>
						<h3 className="mt-4 text-sm font-semibold text-gray-700 dark:text-gray-100">
							{product.name}
						</h3>
						<p className="mt-1 text-lg font-medium text-gray-900 dark:text-gray-200">
							{product.variants.length > 0 && (
								<span className="text-xs">desde </span>
							)}
							{product.variants.length > 0
								? price(
										product.variants.reduce(
											(min, variant) =>
												variant.price < min ? variant.price : min,
											product.price,
										),
									)
								: price(product.price)}
						</p>
					</Link>
				))}
			</div>
		</section>
	)
}
